/***
 ** zmf
 ** 该类执行加入小组屏幕扫码绑定，解决小组屏幕与实际组数不同步问题
***/
<template>
    <div class="main-box">
        <div class="page msg_success js_show">
            <div class="weui-msg">
                <div class="weui-msg__icon-area" :style="{opacity:opacity}">
                    <i class="weui-icon_msg weui-icon-success" v-if="success" ></i>
                    <i class="weui-icon_msg weui-icon-warn" v-if="!success"  ></i>
                </div>
                <div class="weui-msg__text-area">
                    <h2 class="weui-msg__title">{{msg}}</h2>
                    <p class="weui-msg__desc">{{content}}</p>
                </div>
                <div class="weui-msg__opr-area">
                    <p class="weui-btn-area">
                        <a href="javascript:void(0);" class="weui-btn weui-btn_primary" style="color:#fff" v-if="success" @click="goCourseware">进入课程</a>
                    </p>
                </div>
                <div class="weui-msg__extra-area">
                    <div class="weui-footer">
                        <p class="weui-footer__links">
                            <a href="javascript:void(0);" class="weui-footer__link">UClass</a>
                        </p>
                        <p class="weui-footer__text">{{GLOBAL.copyright}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as cookie from '@static/js/cookieUtil.js';

	export default{
		data(){
			return{
                opacity : 0,
                success : false,
                commiting : true,
                userId : null,
                flag : false,
                coursewareId : null,
                msg : '正在提交...'
			}
        },
        filters:{

        },
		methods:{
            goCourseware : function(){
                this.$router.replace('/student/courseware/index/' + this.coursewareId + '/' + this.courseware.classId);
            },
            join : function(){
                var _this = this;
                _this.loading = weui.loading('正在提交');
                _this.$axios.post(_this.stuApiUrl + "/sign/join-group", _this.$qs.stringify({
                    mac : _this.mac,
                    coursewareId : _this.coursewareId
                })).then(function (response) {
                    _this.loading.hide();
                    _this.opacity = 1;
                    _this.success = response.data.success;
                    if(!response.data.success){
                        _this.msg = response.data.info;
                        return weui.alert(response.data.info);
                    }
                    weui.toast('绑定设备成功');
                    _this.msg = '绑定设备成功';
                }).catch(function (error) {
                    _this.loading.hide();
                    _this.msg = '签到失败';
                });
            },
            loadData : function(){
                var _this = this;
                _this.loading = weui.loading('正在提交');
                _this.$axios.post(_this.stuApiUrl + "/courseware/detail", _this.$qs.stringify({
                    coursewareId : _this.coursewareId
                })).then(function (response) {
                        _this.loading.hide();
                    if(!response.data.success){
                        _this.msg = response.data.info;
                        return weui.alert(response.data.info);
                    }else{
                        _this.courseware = response.data.courseware;
                        _this.join();
                    }
                }).catch(function (error) {
                    _this.loading.hide();
                    _this.msg = '签到失败';
                });
            }
        },
		mounted(){
            var _this = this;
            _this.mac = this.$route.params.mac;
            _this.coursewareId = this.$route.params.coursewareId;
            _this.loadData();
		},
		beforeDestroy(){
		},
		destroyed(){
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-box{
    position: relative;
    height: 100%;
    padding-bottom: 1rem;
    box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/components/student/user/join-group.vue